import CookieHelper from './cookie';

export default class DataLayerHelper {
    static myAccountLoggedIn() {
        return CookieHelper.has('hfr-type') && CookieHelper.get('hfr-type') === 'USER';
    }

    static myAccount2LoggedIn() {
        if (CookieHelper.has('ma2-login')) {
            const data = JSON.parse(CookieHelper.get('ma2-login'));
            const notExpired = +data.exp * 1000 > Date.now();
            const noRegister = !data.register;
            return notExpired && noRegister;
        }
        return false;
    }

    static myAccountId() {
        if (CookieHelper.has('hfr-type')) {
            return CookieHelper.get('hfr-type') === 'USER' ? CookieHelper.get('hfr-id') : null;
        }
        return null;
    }

    static myAccount2Id() {
        if (CookieHelper.has('ma2-login')) {
            const data = JSON.parse(CookieHelper.get('ma2-login'));
            const notExpired = +data.exp * 1000 > Date.now();
            const noRegister = !data.register;
            return notExpired && noRegister ? data.id : null;
        }
        return null;
    }

    static getAccountId() {
        const accountId = this.myAccountId() ?? this.myAccount2Id();
        return accountId;
    }

    static isLoggedIn() {
        const loggedIn = this.myAccountLoggedIn() || this.myAccount2LoggedIn();
        return loggedIn ? 'LoggedIn' : 'Anonymous';
    }

    static getClientId() {
        const clientId = document.cookie?.split('; ').find((row) => row.startsWith('_ga='))?.split('=')[1] ? document.cookie?.split('; ').find((row) => row.startsWith('_ga='))?.split('=')[1]?.split('.').slice(-2).join('.') : null;
        return clientId;
    }

    static getGclId() {
        const urlParams = new URLSearchParams(window.location.search);
        const gclid = urlParams.get('gclid');

        function getURLParameter(link, param) {
            const paramArray = new URLSearchParams(link);
            if (paramArray && paramArray.get(param)) {
                return paramArray.get(param);
            }
            return null;
        }
        if (!gclid) {
            const url = window.location.toLocaleString();
            if (url.indexOf('gclid') !== -1) {
                const [, query] = url.split('#')[1]?.split('?');
                const pageURL = decodeURIComponent(query);
                return getURLParameter(pageURL, 'gclid');
            }
        }
        return gclid;
    }

    static getCurrencyISO(mapSymbol) {
        const currencyList = {
            GBP: '£',
            EUR: '€',
            USD: '$',
        };

        function mapISOCode(object, value) {
            return Object.keys(object).find((key) => object[key] === value);
        }

        const mappedISO = mapISOCode(currencyList, mapSymbol);
        return mappedISO || mapSymbol;
    }
}

window.HONDA = window.HONDA || {};
window.HONDA.DataLayerHelper = DataLayerHelper;
